// extracted by css-extract-rspack-plugin
export default {"checkbox":"RJI1yDy3MhwXS0Hw"};